import { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import Axios from 'axios';
import { places, excludes as excludesPath } from '../../constants/api';
import { PATH } from '../../envs/core';

const sites = {
  'www.antena3.com': 41,
  'www.lasexta.com': 7,
  'www.ondacero.es': 2
};

export const getPlace = (filter = '') => {
  return Axios.get(`${PATH}${places}${filter}`).then(response => {
    return response.data;
  });
};

export const getChilds = (typeplace, parentId) =>
  getPlace(`typeplace=${typeplace}&parentid=${parentId}&size=1000`);

export const getExcludes = () => {
  const site = sites[window.location.hostname] || 41;

  return Axios.get(`${PATH}${excludesPath}${site}`).then(response => {
    return response.data;
  });
};
export const empty = [];

export const PlacesProvider = ({
  type,
  parentId,
  name,
  children,
  grandParentId,
  size,
  search,
  sortby,
  excludedGrandParentIds,
  includedIds
}) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const parentQuery = parentId ? `&parentid=${parentId}` : '';
    const grandParentQuery = grandParentId ? `&grandpaid=${grandParentId}` : '';
    const nameQuery = name ? `&name=${name}` : '';
    const searchQuery = search ? `&search=${search}` : '';
    const sizeQuery = `&size=${size}`;
    const sortbyQuery = sortby ? `&sortby=${sortby}` : '';
    const typeQuery = type ? `typeplace=${type}` : '';
    const excludedQuery = excludedGrandParentIds.reduce(
      (result, id) => result + `&excludeid=${id}`,
      ''
    );
    const includedQuery = includedIds.reduce(
      (result, id) => result + `&addid=${id}`,
      ''
    );

    const filter = `${typeQuery}${grandParentQuery}${parentQuery}${nameQuery}${sizeQuery}${searchQuery}&page=0${sortbyQuery}${excludedQuery}${includedQuery}`;

    getPlace(filter).then(response => {
      setData(response.content);
    });
  }, [type, parentId, name, grandParentId, search, sortby]);

  return children(data || empty);
};

PlacesProvider.propTypes = {
  type: PropTypes.string.isRequired,
  parentId: PropTypes.string,
  name: PropTypes.string,
  children: PropTypes.func.isRequired,
  size: PropTypes.number,
  excludedGrandParentIds: PropTypes.array,
  includedIds: PropTypes.array
};

PlacesProvider.defaultProps = {
  parentId: '',
  name: '',
  size: 1000,
  excludedGrandParentIds: [],
  includedIds: []
};
